<template>
  <menu-item-abs type="dessert"/>
</template>

<script>
import MenuItemAbs from "./MenuItemAbs";
export default {
  name: "Desserts-List",
  components: {
    MenuItemAbs
  },
  data: () => ({
  }),
  methods: {
  }
};
</script>
